import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=6eb5c8f4&scoped=true"
import script from "./productItem.vue?vue&type=script&lang=js"
export * from "./productItem.vue?vue&type=script&lang=js"
import style0 from "./productItem.vue?vue&type=style&index=0&id=6eb5c8f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5c8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb5c8f4')) {
      api.createRecord('6eb5c8f4', component.options)
    } else {
      api.reload('6eb5c8f4', component.options)
    }
    module.hot.accept("./productItem.vue?vue&type=template&id=6eb5c8f4&scoped=true", function () {
      api.rerender('6eb5c8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/children/productItem.vue"
export default component.exports